import { styled } from "goober";

export const StatusText = styled("span")`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: var(--text-secondary);
`;
